import { Box } from "@mui/material";
import CreateRobotMapScreen from "../_form/create-map";
import { useNavigate } from "react-router-dom";

export default function CreateRobotMapPage() {
  const navigate = useNavigate()
  return (
    <Box>
      <CreateRobotMapScreen
        onCancel={() => {
          // Handle cancel action
          navigate("/config/robot-maps", {
            replace: true
          })
        }}
        onSuccess={() => {
          navigate("/config/robot-maps", {
            replace: true
          })
        }}
      />
    </Box>
  )
}